<template>
    <div class="page flex flex-col md:border-l md:border-r">
        <TopBarBg :headerText="'oversea'" small :canGoBack="true"></TopBarBg>
        <PageContent
            class="flex-auto"
            :hasPoweredBy="hasPoweredBy"
            rounded
            :marginTop="0"
            :paddingTop="0"
        >
        <div class="mx-18px mb-6 -mt-14">
            <CategoryList
                :modalController="modalController"
                @onLoaded="onLoadSuccess()"
            ></CategoryList>
        </div>
        </PageContent>
        <Footer :hasPoweredBy="hasPoweredBy" />
    </div>

    <div class="flyout-zone">
        <ModalMaster :controller="modalController"></ModalMaster>
    </div>
</template>
<script>
import TopBarBg from "@/components/Layout/TopBar/TopBarBg.vue"
import PageContent from "@/components/Layout/Content/PageContent.vue"
import Footer from "@/components/Layout/Footer/Footer.vue"
import ModalMaster from "@/components/Modal/ModalMaster.vue"
import CategoryList from "../component/CategoryList.vue"

// helper
// import Locale from "@/helper/locale/Locale.js";
import AccountHelper from "@/helper/AccountHelper"

// mixins
import ModalMixin from "@/mixin/ModalMixin"
import LocaleMixin from "@/mixin/LocaleMixin"
import ErrorApiMixin from "@/mixin/ErrorApiMixin"

// service

// config
import ConfigManager from "@/config/ConfigManager";

export default {
    name: 'PlatinumServiceCampaignsPage',
    props: {},
    components: {
        TopBarBg,
        PageContent,
        Footer,
        ModalMaster,
        CategoryList
    },
    mixins: [LocaleMixin, ModalMixin, ErrorApiMixin],
    emits: [],
    data: function () {
        return {
            hasPoweredBy: false,
            categoryItems: [],
            dashboardConfig: ConfigManager.getDashboardConfig(),
            campaignListConfig: ConfigManager.getCampaignPlatinumService(),
            categoryConfig: ConfigManager.getCategoryPlatinumService(),
            tab: 0,
            campaignItems: [],
            listConfig: null,
            filterConfig: null,
            trackingScreenName: 'searching_promotion_oversea',
        }
    },
    computed: {},
    watch: {
        tab: function (val) {
            this.$router.replace({
                params: {
                    cat: val
                }
            })

            this.generateConfig()
        }
    },
    created: function () {
        this.init()
    },
    mounted: function () {
        this.loadingModal.show()
        this.tracking.screenName(this.trackingScreenName);
        // this.renderCampaigns()
    },
    methods: {
        // init is laoading category
        init: function () {
            let user = AccountHelper.getCacheUser()
            console.log(user)
            if (user == null) {
                // show bottom sheet
            }
        },
        onLoadSuccess: function () {
            this.loadingModal.hide()
        }
    }
}
</script>
